






import { Component, Vue } from "vue-property-decorator";
import ManageVesselGroups from "@/components/VesselGroup/ManageVesselGroups.vue";

@Component({
  components: {
    ManageVesselGroups,
  },
})
export default class VesselGroupsWrapper extends Vue {
}
